<div echarts [options]="chartOptions"></div>
